import React from "react";
import { Modal, Row, Col } from "antd";
import moment from "moment";

const RowForm = props => <Row style={{ padding: "5px 10px" }}>{props.children}</Row>;

const ModalDetailBooking = ({ showModalDetail, toggleModalDetail, dataBooking }) => {
  return dataBooking.id ? (
    <Modal
      title="Detail Booking"
      visible={showModalDetail}
      onOk={() => toggleModalDetail(false)}
      onCancel={() => toggleModalDetail(false)}
      width={700}
    >
      <p>Detail Booking</p>
      <RowForm>
        <Col span={8}>Nama Sales</Col>
        <Col span={16}>: {dataBooking.SalesProfile.name}</Col>
      </RowForm>
      <RowForm>
        <Col span={8}>Cabang</Col>
        <Col span={16}>: {dataBooking.SalesProfile.branch}</Col>
      </RowForm>
      <RowForm>
        <Col span={8}>Car Inquiry Created</Col>
        <Col span={16}>
          :{" "}
          {dataBooking.CarInquiry
            ? moment(dataBooking.CarInquiry.createdAt, "YYYY-MM-DDTHH:mm").format("dddd, D MMMM YYYY")
            : "-"}
        </Col>
      </RowForm>
      <RowForm>
        <Col span={8}>Waktu Appraisal</Col>
        <Col span={16}>: {moment(dataBooking.bookingTime, "YYYY-MM-DDTHH:mm").format("dddd, D MMMM YYYY")}</Col>
      </RowForm>
      <RowForm>
        <Col span={8}>Jam</Col>
        <Col span={16}>: {moment(dataBooking.bookingTime, "YYYY-MM-DDTHH:mm").format("HH : mm")}</Col>
      </RowForm>
      <RowForm>
        <Col span={8}>Nama Appraisal</Col>
        <Col span={16}>: {dataBooking.Appraiser ? dataBooking.Appraiser.name : "-"}</Col>
      </RowForm>
      <RowForm>
        <Col span={8}>Mobil</Col>
        <Col span={16}>: {dataBooking.carType}</Col>
      </RowForm>
      <RowForm>
        <Col span={8}>No. Polisi</Col>
        <Col span={16}>: {dataBooking.CarInquiry ? dataBooking.CarInquiry.licensePlate : "-"}</Col>
      </RowForm>
    </Modal>
  ) : null;
};

export default ModalDetailBooking;



// WEBPACK FOOTER //
// src/components/Dashboard/Overview/ModalDetail.js